import React, { useCallback, useEffect, useRef } from 'react';
import 'wicg-inert';
import Portal from 'atoms/Portal/Portal';
import styles from './PortalBackdrop.module.scss';
function PortalBackdrop(props) {
    const { opened, active, locked = false, zIndex, children, onClose } = props;
    const backdrop = useRef(null);
    const handlePortalClose = useCallback(() => {
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    useEffect(() => {
        const { current } = backdrop;
        const keyHandler = (e) => !locked && [27].indexOf(e.which) >= 0 && handlePortalClose();
        const clickHandler = (e) => !locked && e.target === current && handlePortalClose();
        if (current) {
            current.addEventListener('click', clickHandler);
            window.addEventListener('keyup', keyHandler);
        }
        if (opened) {
            window.setTimeout(() => {
                var _a;
                (_a = document.querySelector('#root')) === null || _a === void 0 ? void 0 : _a.setAttribute('inert', 'true');
                document.body.style.overflow = 'hidden';
            }, 10);
        }
        return () => {
            var _a;
            if (current) {
                current.removeEventListener('click', clickHandler);
            }
            (_a = document.querySelector('#root')) === null || _a === void 0 ? void 0 : _a.removeAttribute('inert');
            document.body.style.overflow = 'unset';
            window.removeEventListener('keyup', keyHandler);
        };
    }, [opened, locked, onClose, handlePortalClose]);
    return opened ? (React.createElement(Portal, { className: styles.portal, zIndex: zIndex },
        React.createElement("div", { ref: backdrop, className: `${styles.backdrop} ${active && styles.backdropActive}` }),
        children)) : null;
}
export default PortalBackdrop;
